
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/cendyn",
      function () {
        return require("private-next-pages/destinations/cendyn.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/cendyn"])
      });
    }
  